import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ddf22186"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tournament-table" }
const _hoisted_2 = { class: "t-table-header-sub" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "i-am-just-here-for-cheating-on-flexbox" }, null, -1))
const _hoisted_4 = { class: "t-table" }
const _hoisted_5 = { width: "15%" }
const _hoisted_6 = { width: "25%" }
const _hoisted_7 = { width: "25%" }
const _hoisted_8 = { width: "20%" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icf-info" }, null, -1))
const _hoisted_10 = { "data-qe-id": "table-data" }
const _hoisted_11 = ["data-qe-id"]
const _hoisted_12 = {
  key: 0,
  "data-qe-id": "current-score"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "inline-info",
  "data-qe-id": "previous-best-score"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icf-info info-icon" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icf-arrowBottom" }, null, -1))
const _hoisted_17 = {
  key: 1,
  class: "highlighted",
  "data-qe-id": "tr-data-highlighted--outside"
}
const _hoisted_18 = {
  key: 2,
  class: "search-not-found"
}
const _hoisted_19 = {
  key: 1,
  class: "no-results",
  "data-qe-id": "no-results-available-row"
}

import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from '@/store'
import { marked } from 'marked'
import { TournamentRanking } from '@/model/ranking/TournamentRankings'
import { State } from '@/store/state'
import { Sorting, SortFilter, SortOrder } from '@/model/ranking/Sorting'
import CTableHeadColumn from '@/components/ranking/CTableHeadColumn.vue'
import CSearchInput from '@/components/CSearchInput.vue'
import { jslog } from '@gd/jslog'
import { track } from '@/lib/track'

const COLSPAN_NUM = 5
const ENTRIES_PER_BATCH = 50

export default /*#__PURE__*/_defineComponent({
  __name: 'MTournamentTable',
  props: {
    tId: {},
    showHistoryMode: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props
const route = useRoute()
const store = useStore()

const SORT_FILTER = SortFilter

const entriesToRender = ref(ENTRIES_PER_BATCH)
const searchTerm = ref('')

function loadData(tId: string) {
  store.dispatch('ranking/tournament/fetch', tId).catch((err) => {
    jslog.send({ name: 'fatal', data: { message: `could not load tournament table for: ${tId}` } })
  })
}

watch(
  () => props.tId,
  (to) => loadData(to)
)

watch(
  () => store.state.tournament.joined,
  () => loadData(props.tId)
)

function md(text: string): string {
  return marked(text)
}

/**
 * Range of TournamentRankings rendered on screen
 */
const tournamentRankingsRange = computed((): Array<TournamentRanking> => {
  if (isSearchActive.value) {
    return store.getters['ranking/tournament/usersByName'](searchTerm.value, 0, entriesToRender.value)
  }
  return store.getters['ranking/tournament/rankings'](0, entriesToRender.value)
})

/**
 * Sorting stored in ranking/tournament
 */
const currentSorting = computed((): SortOrder => {
  return store.state.ranking.tournament.sorting
})

/**
 * My TournamentRanking dataset filtered from ranking/tournament store
 */
const myRanking = computed((): TournamentRanking => {
  return store.getters['ranking/tournament/rankings']().filter(
    (ranking: TournamentRanking) => ranking.playerId === store.getters.userId
  )[0]
})

/**
 * Displayed in column 'Number of played games'
 */
const maxGamesPerTournament = computed((): number => {
  return (store.state as State).tournament.metaData.numberOfGames
})

/**
 * Amount of all TournamentRankings in store
 */
const maxEntries = computed(() => {
  if (isSearchActive.value) {
    return store.getters['ranking/tournament/usersByName'](searchTerm.value).length
  }
  return store.getters['ranking/tournament/rankings']().length
})

/**
 * Consider search as active when minimum amount of characters is reached
 */
const isSearchActive = computed(() => {
  return searchTerm.value.length > 0
})

function isMyUser(ranking: TournamentRanking): boolean {
  // userId in userData call does not contain leading "u", table data does have a "u"?
  return store.getters.userId === ranking.playerId
}

const hasPlayedGames = computed(() => {
  return (store.state as State).tournament.games.length > 0
})

const isMyUserInViewPort = computed((): boolean => {
  const userId = store.getters.userId
  const filteredUsers = tournamentRankingsRange.value.filter((ranking) => ranking.playerId === userId)
  return filteredUsers.length > 0
})

/**
 * Event handling
 */
function onShowMore() {
  if (entriesToRender.value + ENTRIES_PER_BATCH <= maxEntries.value) {
    entriesToRender.value += ENTRIES_PER_BATCH
    track({
      path: route.fullPath,
      id: 'tournamentTable',
      elem: 'load-more',
    })
  } else {
    entriesToRender.value = maxEntries.value
  }
}

function onToggleSorting(sorting: Sorting) {
  store.commit('ranking/tournament/sorting', sorting.order)
  track({
    path: route.fullPath,
    id: 'tournamentTable',
    elem: 'toggle-sorting',
    data: sorting.order,
  })
}

function onSearchTerm(term: string) {
  searchTerm.value = term
}
loadData(props.tId)

return (_ctx: any,_cache: any) => {
  const _component_t_tooltip = _resolveComponent("t-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(CSearchInput, {
        onOnChange: onSearchTerm,
        placeholder: _ctx.$t('table.search.input_placeholder'),
        "data-qe-id": "search-input"
      }, null, 8, ["placeholder"])
    ]),
    _createElementVNode("table", _hoisted_4, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.$t('table.columns.rank')), 1),
          _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.$t('table.columns.playerName')), 1),
          _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.$t('table.columns.score')), 1),
          _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t('table.columns.gamesFinished')), 1),
          _createVNode(CTableHeadColumn, {
            width: "15%",
            "is-selected": true,
            "sort-filter": _unref(SORT_FILTER).TotalWin,
            "sort-order": currentSorting.value,
            onToggleSorting: onToggleSorting,
            "qe-id": "sort-by-prize"
          }, {
            icon: _withCtx(() => [
              (!_ctx.showHistoryMode)
                ? (_openBlock(), _createBlock(_component_t_tooltip, {
                    key: 0,
                    class: "tooltip",
                    text: _ctx.$t('table.info.totalWin')
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }, 8, ["text"]))
                : _createCommentVNode("", true)
            ]),
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('table.columns.totalWin')) + " ", 1)
            ]),
            _: 1
          }, 8, ["sort-filter", "sort-order"])
        ])
      ]),
      _createElementVNode("tbody", _hoisted_10, [
        (tournamentRankingsRange.value.length > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tournamentRankingsRange.value, (entry) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: entry.playerName,
                  class: _normalizeClass(isMyUser(entry) ? 'highlighted' : ''),
                  "data-qe-id": isMyUser(entry) ? 'tr-data-highlighted' : 'tr-data'
                }, [
                  _createElementVNode("td", null, _toDisplayString(entry.tournamentRank), 1),
                  _createElementVNode("td", null, _toDisplayString(entry.playerName), 1),
                  _createElementVNode("td", null, [
                    (isMyUser(entry))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.showHistoryMode || hasPlayedGames.value ? entry.tournamentScore : '-'), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(entry.tournamentScore), 1)),
                    (
                  !_ctx.showHistoryMode &&
                  entry.playerId === _unref(store).getters.userId &&
                  _unref(store).state.ranking.tournament.prevBestScore
                )
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                          _createTextVNode(" (" + _toDisplayString(_ctx.$t('tViews.joined.text_tournamentInfo_bestScorePartial', {
                    prevBestScore: _unref(store).state.ranking.tournament.prevBestScore,
                  })) + " ", 1),
                          _createVNode(_component_t_tooltip, {
                            text: _ctx.$t('table.info.previousPoints')
                          }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          }, 8, ["text"]),
                          _createTextVNode(") ")
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(entry.playedGames) + " / " + _toDisplayString(maxGamesPerTournament.value), 1),
                  _createElementVNode("td", null, _toDisplayString(entry.totalWin), 1)
                ], 10, _hoisted_11))
              }), 128)),
              (maxEntries.value > entriesToRender.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: "dots",
                        colspan: COLSPAN_NUM
                      }, "• • •")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", {
                        class: "show-more-row",
                        colspan: COLSPAN_NUM,
                        onClick: onShowMore,
                        "data-qe-id": "show-more-link"
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('table.more.button')) + " ", 1),
                        _hoisted_16
                      ])
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (!isSearchActive.value && myRanking.value && !isMyUserInViewPort.value)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                    _createElementVNode("td", null, _toDisplayString(myRanking.value.tournamentRank), 1),
                    _createElementVNode("td", null, _toDisplayString(myRanking.value.playerName), 1),
                    _createElementVNode("td", null, _toDisplayString(myRanking.value.tournamentScore), 1),
                    _createElementVNode("td", null, _toDisplayString(myRanking.value.playedGames) + " / " + _toDisplayString(maxGamesPerTournament.value), 1),
                    _createElementVNode("td", null, _toDisplayString(myRanking.value.totalWin), 1)
                  ]))
                : _createCommentVNode("", true),
              (isSearchActive.value && tournamentRankingsRange.value.length === 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                    _createElementVNode("td", { colspan: COLSPAN_NUM }, _toDisplayString(_ctx.$t('table.search.results_not_found')), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock("tr", _hoisted_19, [
              _createElementVNode("td", { colspan: COLSPAN_NUM }, _toDisplayString(_ctx.$t('table.more.no_results')), 1)
            ]))
      ])
    ])
  ]))
}
}

})